import { render, staticRenderFns } from "./RejectDialog.vue?vue&type=template&id=e5106d7c&scoped=true"
import script from "./RejectDialog.vue?vue&type=script&lang=js"
export * from "./RejectDialog.vue?vue&type=script&lang=js"
import style0 from "./RejectDialog.vue?vue&type=style&index=0&id=e5106d7c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5106d7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5106d7c')) {
      api.createRecord('e5106d7c', component.options)
    } else {
      api.reload('e5106d7c', component.options)
    }
    module.hot.accept("./RejectDialog.vue?vue&type=template&id=e5106d7c&scoped=true", function () {
      api.rerender('e5106d7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/advertising/components/RejectDialog.vue"
export default component.exports